






























































































































































import { Configuration } from "@/model/data/security/Configuration";
import { DelayTypeEnum } from "@/model/data/enums/DelayTypeEnum";
import Vue from "vue";
import { formatSeconds } from "@/utility/Formatter";
import { AlarmFlagsEnum } from "@/model/data/enums/AlarmFlagsEnum";
import { mapGetters } from "vuex";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { TimeBandFlagsEnum } from "@/model/data/enums/TimeBandFlagEnum";
import { TemplateContentEnum } from "@/model/data/enums/TemplateContentEnum";
export default Vue.extend({
    props: {
        configuration: { type: Object as () => Configuration, required: true },
        templateContent: Number as () => TemplateContentEnum,
    },
    data() {
        return {
            DelayTypeEnum,
            reservationsTableHeader: [
                { text: this.$t("security_management.delayAmount"), value: "amount", align: "center", sortable: false },
                { text: this.$t("security_management.delayTime"), value: "delay", align: "center", sortable: false },
            ],
            emptyOutTableHeader: [
                { text: this.$t("security_management.delayAmount"), value: "amount", align: "center", sortable: false },
                { text: this.$t("security_management.delayTime"), value: "delay", align: "center", sortable: false },
            ],
            limitationsTableHeader: [
                { text: this.$t("security_management.delayAmount"), value: "amount", align: "center", sortable: false },
                { text: this.$t("security_management.delayTime"), value: "delay", align: "center", sortable: false },
            ],
            days: [
                this.$t("common.dayOfWeek.monday"),
                this.$t("common.dayOfWeek.tuesday"),
                this.$t("common.dayOfWeek.wednesday"),
                this.$t("common.dayOfWeek.thursday"),
                this.$t("common.dayOfWeek.friday"),
                this.$t("common.dayOfWeek.saturday"),
                this.$t("common.dayOfWeek.sunday"),
            ],
        };
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),

        delaysEnabled() {
            if (this.templateContent) {
                if ((this.templateContent & TemplateContentEnum.Delays) == TemplateContentEnum.None) return false;
            }
            return this.authUserHasPrivilege(ClientPrivileges.ReadDelays);
        },

        alarmsEnabled() {
            if (this.templateContent) {
                if ((this.templateContent & TemplateContentEnum.Alarms) == TemplateContentEnum.None) return false;
            }
            return this.authUserHasPrivilege(ClientPrivileges.ReadAlarms);
        },

        timebandsEnabled() {
            if (this.templateContent) {
                if ((this.templateContent & TemplateContentEnum.TimeBands) == TemplateContentEnum.None) return false;
            }
            return this.authUserHasPrivilege(ClientPrivileges.ReadBands);
        },

        reservations: {
            get() {
                let reservations = [];
                if (this.configuration && this.configuration.delays) {
                    reservations = this.configuration.delays
                        .filter((d) => d.type == DelayTypeEnum.Reservation && d.amount != 0)
                        .sort(function (a, b) {
                            return a.amount - b.amount;
                        });
                }
                return reservations;
            },
        },
        permanence: {
            get() {
                let permanence = 0;
                if (this.configuration && this.configuration.delays) {
                    let p = this.configuration.delays.filter((d) => d.type == DelayTypeEnum.Permanence && d.delay != 0);
                    if (p && p.length) {
                        permanence = p[0].delay;
                    }
                }
                return permanence;
            },
        },
        emptyOut: {
            get() {
                if (this.configuration && this.configuration.delays) {
                    let emptyOut = this.configuration.delays.filter((d) => d.type == DelayTypeEnum.Emptyout);
                    return emptyOut[0];
                }
                return null;
            },
        },
        limitations: {
            get() {
                let limitations = [];
                if (this.configuration && this.configuration.delays) {
                    limitations = this.configuration.delays.filter((d) => d.type == DelayTypeEnum.Limitation && d.amount != 0 && d.delay != 0);
                }
                return limitations[0];
            },
        },
        emptyOutOption: {
            get() {
                let emptyOutOption = 0;
                if (this.configuration && this.configuration.delays) {
                    let p = this.configuration.delays.filter((d) => d.type == DelayTypeEnum.Permanence);
                    if (p && p.length) {
                        emptyOutOption = p[0].options;
                    }
                }
                return emptyOutOption;
            },
        },
        alarmLabels() {
            let alarmLabels = [];
            if (this.configuration && this.configuration.alarms && this.configuration.alarms.length) {
                for (let alarm of this.configuration.alarms) {
                    let labels = [];
                    if ((alarm & AlarmFlagsEnum.OverThirdBandWithdrawal) != AlarmFlagsEnum.None) labels.push(this.$t("security_management.alarm1"));
                    if ((alarm & AlarmFlagsEnum.EmptyInAlarmTimeBand) != AlarmFlagsEnum.None) labels.push(this.$t("security_management.alarm2"));
                    if ((alarm & AlarmFlagsEnum.commandCA) != AlarmFlagsEnum.None) labels.push(this.$t("security_management.alarm4"));
                    if ((alarm & AlarmFlagsEnum.DoorOpen) != AlarmFlagsEnum.None) labels.push(this.$t("security_management.alarm8"));
                    if ((alarm & AlarmFlagsEnum.WriteParameters) != AlarmFlagsEnum.None) labels.push(this.$t("security_management.alarm16"));
                    alarmLabels.push(labels);
                }
            }
            return alarmLabels;
        },
        timeBands() {
            if (this.configuration && this.configuration.timeBands && this.configuration.timeBands.length) {
                return this.configuration.timeBands;
            }
            return [];
        },
    },
    methods: {
        formatSeconds,
        getDelayAmountLowerBound(amount: number) {
            for (let i = 0; i < this.reservations.length; i++) {
                if (this.reservations[i].amount == amount) {
                    if (i == 0) return `0 - ${amount}`;
                    else return `${this.reservations[i - 1].amount + 1} - ${amount}`;
                }
            }
        },
        optionsToLabel(options: TimeBandFlagsEnum) {
            let label = [];
            if ((options & TimeBandFlagsEnum.OperatingMachine) != TimeBandFlagsEnum.None) label.push(this.$t("security_management.operatingMachine"));
            else if ((options & TimeBandFlagsEnum.OnlyDeposit) != TimeBandFlagsEnum.None) label.push(this.$t("security_management.onlyDeposit"));
            else label.push(this.$t("security_management.notOperatingMachine"));
            if ((options & TimeBandFlagsEnum.EmptyoutPossible) != TimeBandFlagsEnum.None) label.push(this.$t("security_management.emptyoutPossible"));
            else if ((options & TimeBandFlagsEnum.EmptyoutPossibleWithAlarm) != TimeBandFlagsEnum.None) label.push(this.$t("security_management.emptyoutPossibleWithAlarm"));
            else label.push(this.$t("security_management.emptyoutNotPossible"));
            if ((options & TimeBandFlagsEnum.DoorOpen) != TimeBandFlagsEnum.None) label.push(this.$t("security_management.doorOpen"));
            else if ((options & TimeBandFlagsEnum.DoorOpenWithAlarm) != TimeBandFlagsEnum.None) label.push(this.$t("security_management.doorOpenWithAlarm"));
            else label.push(this.$t("security_management.doorNotOpen"));
            return label;
        },
    },
});
